import { pathnames } from 'constants/pathnames';

const { mainPage, contactsPage, ballroomPage, streetDancePage, caribbeanDancePage, constructionPage } = pathnames;

export const contactUsBlockPages = [mainPage, contactsPage, ballroomPage];

export const constructionPages = [constructionPage, streetDancePage, caribbeanDancePage];
